import { render } from "./KidsProduct.vue?vue&type=template&id=3e544bb0&scoped=true"
import script from "./KidsProduct.vue?vue&type=script&lang=js"
export * from "./KidsProduct.vue?vue&type=script&lang=js"

import "./KidsProduct.vue?vue&type=style&index=0&id=3e544bb0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e544bb0"]])

export default __exports__